import React from 'react';
import { AlertCircle, ArrowRight } from 'lucide-react';
import { Alert, AlertDescription, AlertTitle } from './ui/alert';
import { Button } from './ui/button';
import { Link } from 'react-router-dom';
import { useGlobalState } from '../contexts/GlobalStateContext';
import { useProjects } from '../contexts/ProjectContext';

export default function DowngradeBanner() {
    const { user } = useGlobalState();
    const { projects } = useProjects();

    if (!user || user.tier === 'AGENCY' || user.tier === 'PRO') return null;

    // Tier limits
    const maxProjects = user.tier === 'BASIC' ? 1 : 0;
    const activeProjectsCount = projects.filter(p => !p.archived).length;

    if (activeProjectsCount <= maxProjects) return null;

    // Find the oldest project (the only one editable)
    const sortedProjects = [...projects].sort((a, b) =>
        new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
    );
    const editableProject = sortedProjects[0];

    return (
        <div className="mb-6 animate-in fade-in slide-in-from-top-4 duration-500">
            <Alert variant="destructive" className="bg-orange-500/10 border-orange-500/20 text-orange-200 py-4 px-6 rounded-2xl shadow-xl shadow-orange-500/5">
                <AlertCircle className="h-5 w-5 text-orange-500" />
                <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 w-full">
                    <div>
                        <AlertTitle className="text-orange-500 font-black uppercase tracking-widest text-[10px] mb-1">
                            Subscription Limit Reached
                        </AlertTitle>
                        <AlertDescription className="text-orange-200/80 font-medium">
                            You are over the project limit for your plan. Currently, only <span className="text-white font-bold">"{editableProject?.name}"</span> is editable.
                            Archive other projects or upgrade to regain full access.
                        </AlertDescription>
                    </div>
                    <Button asChild size="sm" className="bg-orange-500 hover:bg-orange-600 text-white font-black rounded-xl px-6 shrink-0 shadow-lg shadow-orange-500/20">
                        <Link to="/pricing">
                            Upgrade Plan
                            <ArrowRight className="ml-2 h-4 w-4" />
                        </Link>
                    </Button>
                </div>
            </Alert>
        </div>
    );
}
